'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-cart-upsale-box
 * @restrict E
 *
 * @description
 * #directive
 * Not implemented : displays the upsell information returned by process-selection
 *
 * @template:'<v-tv-package-btn-refresh-basket data-btn-theme></v-tv-package-btn-refresh-basket><div class="upsale-box content-box box3d"><h2>Recommandation</h2><div class="upsale-content"><p>Some upsale stuff content here.</p><p>Some upsale stuff content here.</p><p>Some upsale stuff content here.</p></div><div class="v-action-buttons"><button type="button" class="theme-1-btn">Sélectionner ce forfait</button></div></div>'
 * @param {string} btnTheme A class to add to the refresh button to apply a specific css style
 */

angular.module('v-tv-package').component('vTvPackageCartUpsaleBox', {
    bindings: {
        btnTheme: '@'
    },
    template:'<v-tv-package-btn-refresh-basket data-btn-theme></v-tv-package-btn-refresh-basket><div class="upsale-box content-box box3d"><h2>Recommandation</h2><div class="upsale-content"><p>Some upsale stuff content here.</p><p>Some upsale stuff content here.</p><p>Some upsale stuff content here.</p></div><div class="v-action-buttons"><button type="button" class="theme-1-btn">Sélectionner ce forfait</button></div></div>'
});